/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// @ts-ignore
import * as runtime from '../runtime';
// @ts-ignore
import type {
// @ts-ignore
  AddProofOfPaymentRequest,
// @ts-ignore
  BulkOrderCreateRequest,
// @ts-ignore
  BulkOrderCreateResponse,
// @ts-ignore
  DailyOrderMetricsResult,
// @ts-ignore
  ErrorResponse,
// @ts-ignore
  GoodsReceivedNote,
// @ts-ignore
  MonthlyOrderMetricsResult,
// @ts-ignore
  Order,
// @ts-ignore
  OrderAttentionListResponse,
// @ts-ignore
  OrderCreateRequest,
// @ts-ignore
  OrderCreateResult,
// @ts-ignore
  OrderExportRequest,
// @ts-ignore
  OrderIncompleteDelivery,
// @ts-ignore
  OrderIncompleteDeliveryCreateRequest,
// @ts-ignore
  OrderIncompleteDeliveryResolveRequest,
// @ts-ignore
  OrderListResponse,
// @ts-ignore
  OrderReject,
// @ts-ignore
  OrderStatus,
// @ts-ignore
  OrderUpdateRequest,
// @ts-ignore
  StoreOrderVarianceListResponse,
// @ts-ignore
  SupplierStoreOrderVarianceListResponse,
} from '../models/index';
// @ts-ignore
import {
// @ts-ignore
    AddProofOfPaymentRequestFromJSON,
// @ts-ignore
    AddProofOfPaymentRequestToJSON,
// @ts-ignore
    BulkOrderCreateRequestFromJSON,
// @ts-ignore
    BulkOrderCreateRequestToJSON,
// @ts-ignore
    BulkOrderCreateResponseFromJSON,
// @ts-ignore
    BulkOrderCreateResponseToJSON,
// @ts-ignore
    DailyOrderMetricsResultFromJSON,
// @ts-ignore
    DailyOrderMetricsResultToJSON,
// @ts-ignore
    ErrorResponseFromJSON,
// @ts-ignore
    ErrorResponseToJSON,
// @ts-ignore
    GoodsReceivedNoteFromJSON,
// @ts-ignore
    GoodsReceivedNoteToJSON,
// @ts-ignore
    MonthlyOrderMetricsResultFromJSON,
// @ts-ignore
    MonthlyOrderMetricsResultToJSON,
// @ts-ignore
    OrderFromJSON,
// @ts-ignore
    OrderToJSON,
// @ts-ignore
    OrderAttentionListResponseFromJSON,
// @ts-ignore
    OrderAttentionListResponseToJSON,
// @ts-ignore
    OrderCreateRequestFromJSON,
// @ts-ignore
    OrderCreateRequestToJSON,
// @ts-ignore
    OrderCreateResultFromJSON,
// @ts-ignore
    OrderCreateResultToJSON,
// @ts-ignore
    OrderExportRequestFromJSON,
// @ts-ignore
    OrderExportRequestToJSON,
// @ts-ignore
    OrderIncompleteDeliveryFromJSON,
// @ts-ignore
    OrderIncompleteDeliveryToJSON,
// @ts-ignore
    OrderIncompleteDeliveryCreateRequestFromJSON,
// @ts-ignore
    OrderIncompleteDeliveryCreateRequestToJSON,
// @ts-ignore
    OrderIncompleteDeliveryResolveRequestFromJSON,
// @ts-ignore
    OrderIncompleteDeliveryResolveRequestToJSON,
// @ts-ignore
    OrderListResponseFromJSON,
// @ts-ignore
    OrderListResponseToJSON,
// @ts-ignore
    OrderRejectFromJSON,
// @ts-ignore
    OrderRejectToJSON,
// @ts-ignore
    OrderStatusFromJSON,
// @ts-ignore
    OrderStatusToJSON,
// @ts-ignore
    OrderUpdateRequestFromJSON,
// @ts-ignore
    OrderUpdateRequestToJSON,
// @ts-ignore
    StoreOrderVarianceListResponseFromJSON,
// @ts-ignore
    StoreOrderVarianceListResponseToJSON,
// @ts-ignore
    SupplierStoreOrderVarianceListResponseFromJSON,
// @ts-ignore
    SupplierStoreOrderVarianceListResponseToJSON,
} from '../models/index';

export interface AcceptOrderRequest {
    id: string;
}

export interface AddProofOfPaymentOperationRequest {
    id: string;
    addProofOfPaymentRequest: AddProofOfPaymentRequest;
}

export interface BulkCreateOrdersRequest {
    bulkOrderCreateRequest: BulkOrderCreateRequest;
}

export interface CancelOrderRequest {
    id: string;
}

export interface CompleteOrderRequest {
    id: string;
}

export interface CreateOrderRequest {
    orderCreateRequest?: OrderCreateRequest;
}

export interface DispatchOrderRequest {
    id: string;
}

export interface ExportOrdersRequest {
    orderExportRequest: OrderExportRequest;
    query?: string;
    limit?: number;
    offset?: number;
    orderId?: Array<string>;
    supplierId?: string;
    status?: OrderStatus;
}

export interface GetOrderDetailsRequest {
    id: string;
    include?: Array<string>;
    limit?: number;
    offset?: number;
}

export interface ListDailyOrderMetricsRequest {
    start: Date;
    end: Date;
    storeId?: string;
    supplierId?: string;
    currencyCode?: string;
    status?: OrderStatus;
}

export interface ListMonthlyOrderMetricsRequest {
    start: Date;
    end: Date;
    storeId?: string;
    supplierId?: string;
    currencyCode?: string;
    status?: OrderStatus;
}

export interface ListOrderAttentionItemsRequest {
    supplierId?: string;
    storeId?: string;
    limit?: number;
    offset?: number;
}

export interface ListOrdersRequest {
    query?: string;
    include?: Array<string>;
    limit?: number;
    offset?: number;
    orderId?: Array<string>;
    storeId?: string;
    supplierId?: string;
    status?: OrderStatus;
    start?: Date;
    end?: Date;
    sortBy?: Array<string>;
    sortDirection?: Array<ListOrdersSortDirectionEnum>;
}

export interface ListStoreOrderVariancesRequest {
    orderId?: Array<string>;
    supplierId?: string;
    storeId?: string;
    varianceThresholdPercent?: ListStoreOrderVariancesVarianceThresholdPercentEnum;
    limit?: number;
    offset?: number;
}

export interface ListSupplierStoreOrderVariancesRequest {
    supplierId?: string;
    storeId?: string;
    varianceThresholdPercent?: ListSupplierStoreOrderVariancesVarianceThresholdPercentEnum;
    minimumOverdueDays?: ListSupplierStoreOrderVariancesMinimumOverdueDaysEnum;
    limit?: number;
    offset?: number;
}

export interface ReceiveOrderRequest {
    id: string;
}

export interface RejectOrderRequest {
    id: string;
    orderReject?: OrderReject;
}

export interface ReportOrderIncompleteDeliveryRequest {
    id: string;
    orderIncompleteDeliveryCreateRequest: OrderIncompleteDeliveryCreateRequest;
}

export interface ResolveOrderIncompleteDeliveryRequest {
    id: string;
    incompleteDeliveryId: string;
    orderIncompleteDeliveryResolveRequest: OrderIncompleteDeliveryResolveRequest;
}

export interface SubmitGoodsReceivedNoteRequest {
    id: string;
    goodsReceivedNote: GoodsReceivedNote;
}

export interface SubmitOrderRequest {
    id: string;
}

export interface UpdateOrderRequest {
    id: string;
    orderUpdateRequest?: OrderUpdateRequest;
}

/**
 * 
 */
export class OrdersApi extends runtime.BaseAPI {

    /**
     * Accept an order
     */
    async acceptOrderRaw(requestParameters: AcceptOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling acceptOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders/{id}/accept`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Accept an order
     */
    async acceptOrder(requestParameters: AcceptOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.acceptOrderRaw(requestParameters, initOverrides);
    }

    /**
     * Add a proof of payment for an order
     */
    async addProofOfPaymentRaw(requestParameters: AddProofOfPaymentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling addProofOfPayment.');
        }

        if (requestParameters.addProofOfPaymentRequest === null || requestParameters.addProofOfPaymentRequest === undefined) {
            throw new runtime.RequiredError('addProofOfPaymentRequest','Required parameter requestParameters.addProofOfPaymentRequest was null or undefined when calling addProofOfPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/orders/{id}/proof-of-payment`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddProofOfPaymentRequestToJSON(requestParameters.addProofOfPaymentRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add a proof of payment for an order
     */
    async addProofOfPayment(requestParameters: AddProofOfPaymentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addProofOfPaymentRaw(requestParameters, initOverrides);
    }

    /**
     * Create multiple orders in bulk
     */
    async bulkCreateOrdersRaw(requestParameters: BulkCreateOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkOrderCreateResponse>> {
        if (requestParameters.bulkOrderCreateRequest === null || requestParameters.bulkOrderCreateRequest === undefined) {
            throw new runtime.RequiredError('bulkOrderCreateRequest','Required parameter requestParameters.bulkOrderCreateRequest was null or undefined when calling bulkCreateOrders.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/orders/bulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkOrderCreateRequestToJSON(requestParameters.bulkOrderCreateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkOrderCreateResponseFromJSON(jsonValue));
    }

    /**
     * Create multiple orders in bulk
     */
    async bulkCreateOrders(requestParameters: BulkCreateOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkOrderCreateResponse> {
        const response = await this.bulkCreateOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel an order
     */
    async cancelOrderRaw(requestParameters: CancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling cancelOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders/{id}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancel an order
     */
    async cancelOrder(requestParameters: CancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelOrderRaw(requestParameters, initOverrides);
    }

    /**
     * Complete an order
     */
    async completeOrderRaw(requestParameters: CompleteOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling completeOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders/{id}/complete`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Complete an order
     */
    async completeOrder(requestParameters: CompleteOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.completeOrderRaw(requestParameters, initOverrides);
    }

    /**
     * Create a new order
     */
    async createOrderRaw(requestParameters: CreateOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderCreateResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/orders`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderCreateRequestToJSON(requestParameters.orderCreateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderCreateResultFromJSON(jsonValue));
    }

    /**
     * Create a new order
     */
    async createOrder(requestParameters: CreateOrderRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderCreateResult> {
        const response = await this.createOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Dispatch an order
     */
    async dispatchOrderRaw(requestParameters: DispatchOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling dispatchOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders/{id}/dispatch`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Dispatch an order
     */
    async dispatchOrder(requestParameters: DispatchOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.dispatchOrderRaw(requestParameters, initOverrides);
    }

    /**
     * Export orders
     */
    async exportOrdersRaw(requestParameters: ExportOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.orderExportRequest === null || requestParameters.orderExportRequest === undefined) {
            throw new runtime.RequiredError('orderExportRequest','Required parameter requestParameters.orderExportRequest was null or undefined when calling exportOrders.');
        }

        const queryParameters: any = {};

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.orderId) {
            queryParameters['orderId'] = requestParameters.orderId;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplierId'] = requestParameters.supplierId;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/orders/export`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderExportRequestToJSON(requestParameters.orderExportRequest),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Export orders
     */
    async exportOrders(requestParameters: ExportOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get details of a specific order
     */
    async getOrderDetailsRaw(requestParameters: GetOrderDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Order>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getOrderDetails.');
        }

        const queryParameters: any = {};

        if (requestParameters.include) {
            queryParameters['include'] = requestParameters.include;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFromJSON(jsonValue));
    }

    /**
     * Get details of a specific order
     */
    async getOrderDetails(requestParameters: GetOrderDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Order> {
        const response = await this.getOrderDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get daily aggregated order metrics
     */
    async listDailyOrderMetricsRaw(requestParameters: ListDailyOrderMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyOrderMetricsResult>> {
        if (requestParameters.start === null || requestParameters.start === undefined) {
            throw new runtime.RequiredError('start','Required parameter requestParameters.start was null or undefined when calling listDailyOrderMetrics.');
        }

        if (requestParameters.end === null || requestParameters.end === undefined) {
            throw new runtime.RequiredError('end','Required parameter requestParameters.end was null or undefined when calling listDailyOrderMetrics.');
        }

        const queryParameters: any = {};

        if (requestParameters.storeId !== undefined) {
            queryParameters['storeId'] = requestParameters.storeId;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplierId'] = requestParameters.supplierId;
        }

        if (requestParameters.currencyCode !== undefined) {
            queryParameters['currencyCode'] = requestParameters.currencyCode;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = (requestParameters.start as any).toISOString();
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = (requestParameters.end as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders/metrics/daily`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyOrderMetricsResultFromJSON(jsonValue));
    }

    /**
     * Get daily aggregated order metrics
     */
    async listDailyOrderMetrics(requestParameters: ListDailyOrderMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyOrderMetricsResult> {
        const response = await this.listDailyOrderMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get monthly aggregated order metrics
     */
    async listMonthlyOrderMetricsRaw(requestParameters: ListMonthlyOrderMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MonthlyOrderMetricsResult>> {
        if (requestParameters.start === null || requestParameters.start === undefined) {
            throw new runtime.RequiredError('start','Required parameter requestParameters.start was null or undefined when calling listMonthlyOrderMetrics.');
        }

        if (requestParameters.end === null || requestParameters.end === undefined) {
            throw new runtime.RequiredError('end','Required parameter requestParameters.end was null or undefined when calling listMonthlyOrderMetrics.');
        }

        const queryParameters: any = {};

        if (requestParameters.storeId !== undefined) {
            queryParameters['storeId'] = requestParameters.storeId;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplierId'] = requestParameters.supplierId;
        }

        if (requestParameters.currencyCode !== undefined) {
            queryParameters['currencyCode'] = requestParameters.currencyCode;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = (requestParameters.start as any).toISOString();
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = (requestParameters.end as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders/metrics/monthly`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MonthlyOrderMetricsResultFromJSON(jsonValue));
    }

    /**
     * Get monthly aggregated order metrics
     */
    async listMonthlyOrderMetrics(requestParameters: ListMonthlyOrderMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MonthlyOrderMetricsResult> {
        const response = await this.listMonthlyOrderMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List order attention items
     */
    async listOrderAttentionItemsRaw(requestParameters: ListOrderAttentionItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderAttentionListResponse>> {
        const queryParameters: any = {};

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplierId'] = requestParameters.supplierId;
        }

        if (requestParameters.storeId !== undefined) {
            queryParameters['storeId'] = requestParameters.storeId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders/attention`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderAttentionListResponseFromJSON(jsonValue));
    }

    /**
     * List order attention items
     */
    async listOrderAttentionItems(requestParameters: ListOrderAttentionItemsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderAttentionListResponse> {
        const response = await this.listOrderAttentionItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of orders
     */
    async listOrdersRaw(requestParameters: ListOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderListResponse>> {
        const queryParameters: any = {};

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.include) {
            queryParameters['include'] = requestParameters.include;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.orderId) {
            queryParameters['orderId'] = requestParameters.orderId;
        }

        if (requestParameters.storeId !== undefined) {
            queryParameters['storeId'] = requestParameters.storeId;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplierId'] = requestParameters.supplierId;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = (requestParameters.start as any).toISOString();
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = (requestParameters.end as any).toISOString();
        }

        if (requestParameters.sortBy) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.sortDirection) {
            queryParameters['sortDirection'] = requestParameters.sortDirection;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderListResponseFromJSON(jsonValue));
    }

    /**
     * Get a list of orders
     */
    async listOrders(requestParameters: ListOrdersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderListResponse> {
        const response = await this.listOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List store/order metric variances
     */
    async listStoreOrderVariancesRaw(requestParameters: ListStoreOrderVariancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreOrderVarianceListResponse>> {
        const queryParameters: any = {};

        if (requestParameters.orderId) {
            queryParameters['orderId'] = requestParameters.orderId;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplierId'] = requestParameters.supplierId;
        }

        if (requestParameters.storeId !== undefined) {
            queryParameters['storeId'] = requestParameters.storeId;
        }

        if (requestParameters.varianceThresholdPercent !== undefined) {
            queryParameters['varianceThresholdPercent'] = requestParameters.varianceThresholdPercent;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders/variances/store-orders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreOrderVarianceListResponseFromJSON(jsonValue));
    }

    /**
     * List store/order metric variances
     */
    async listStoreOrderVariances(requestParameters: ListStoreOrderVariancesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreOrderVarianceListResponse> {
        const response = await this.listStoreOrderVariancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List supplier/store order variances
     */
    async listSupplierStoreOrderVariancesRaw(requestParameters: ListSupplierStoreOrderVariancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierStoreOrderVarianceListResponse>> {
        const queryParameters: any = {};

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplierId'] = requestParameters.supplierId;
        }

        if (requestParameters.storeId !== undefined) {
            queryParameters['storeId'] = requestParameters.storeId;
        }

        if (requestParameters.varianceThresholdPercent !== undefined) {
            queryParameters['varianceThresholdPercent'] = requestParameters.varianceThresholdPercent;
        }

        if (requestParameters.minimumOverdueDays !== undefined) {
            queryParameters['minimumOverdueDays'] = requestParameters.minimumOverdueDays;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders/variances/supplier-stores`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierStoreOrderVarianceListResponseFromJSON(jsonValue));
    }

    /**
     * List supplier/store order variances
     */
    async listSupplierStoreOrderVariances(requestParameters: ListSupplierStoreOrderVariancesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierStoreOrderVarianceListResponse> {
        const response = await this.listSupplierStoreOrderVariancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Receive an order
     */
    async receiveOrderRaw(requestParameters: ReceiveOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling receiveOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders/{id}/receive`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Receive an order
     */
    async receiveOrder(requestParameters: ReceiveOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.receiveOrderRaw(requestParameters, initOverrides);
    }

    /**
     * Reject an order
     */
    async rejectOrderRaw(requestParameters: RejectOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling rejectOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/orders/{id}/reject`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderRejectToJSON(requestParameters.orderReject),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reject an order
     */
    async rejectOrder(requestParameters: RejectOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rejectOrderRaw(requestParameters, initOverrides);
    }

    /**
     * Report an incomplete order delivery
     */
    async reportOrderIncompleteDeliveryRaw(requestParameters: ReportOrderIncompleteDeliveryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderIncompleteDelivery>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling reportOrderIncompleteDelivery.');
        }

        if (requestParameters.orderIncompleteDeliveryCreateRequest === null || requestParameters.orderIncompleteDeliveryCreateRequest === undefined) {
            throw new runtime.RequiredError('orderIncompleteDeliveryCreateRequest','Required parameter requestParameters.orderIncompleteDeliveryCreateRequest was null or undefined when calling reportOrderIncompleteDelivery.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/orders/{id}/incomplete-deliveries`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderIncompleteDeliveryCreateRequestToJSON(requestParameters.orderIncompleteDeliveryCreateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderIncompleteDeliveryFromJSON(jsonValue));
    }

    /**
     * Report an incomplete order delivery
     */
    async reportOrderIncompleteDelivery(requestParameters: ReportOrderIncompleteDeliveryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderIncompleteDelivery> {
        const response = await this.reportOrderIncompleteDeliveryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve an incomplete order delivery
     */
    async resolveOrderIncompleteDeliveryRaw(requestParameters: ResolveOrderIncompleteDeliveryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderIncompleteDelivery>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling resolveOrderIncompleteDelivery.');
        }

        if (requestParameters.incompleteDeliveryId === null || requestParameters.incompleteDeliveryId === undefined) {
            throw new runtime.RequiredError('incompleteDeliveryId','Required parameter requestParameters.incompleteDeliveryId was null or undefined when calling resolveOrderIncompleteDelivery.');
        }

        if (requestParameters.orderIncompleteDeliveryResolveRequest === null || requestParameters.orderIncompleteDeliveryResolveRequest === undefined) {
            throw new runtime.RequiredError('orderIncompleteDeliveryResolveRequest','Required parameter requestParameters.orderIncompleteDeliveryResolveRequest was null or undefined when calling resolveOrderIncompleteDelivery.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/orders/{id}/incomplete-deliveries/{incompleteDeliveryId}/resolve`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"incompleteDeliveryId"}}`, encodeURIComponent(String(requestParameters.incompleteDeliveryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderIncompleteDeliveryResolveRequestToJSON(requestParameters.orderIncompleteDeliveryResolveRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderIncompleteDeliveryFromJSON(jsonValue));
    }

    /**
     * Resolve an incomplete order delivery
     */
    async resolveOrderIncompleteDelivery(requestParameters: ResolveOrderIncompleteDeliveryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderIncompleteDelivery> {
        const response = await this.resolveOrderIncompleteDeliveryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit a goods received note (GRN) for an order
     */
    async submitGoodsReceivedNoteRaw(requestParameters: SubmitGoodsReceivedNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling submitGoodsReceivedNote.');
        }

        if (requestParameters.goodsReceivedNote === null || requestParameters.goodsReceivedNote === undefined) {
            throw new runtime.RequiredError('goodsReceivedNote','Required parameter requestParameters.goodsReceivedNote was null or undefined when calling submitGoodsReceivedNote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/orders/{id}/goods-received-note`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GoodsReceivedNoteToJSON(requestParameters.goodsReceivedNote),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Submit a goods received note (GRN) for an order
     */
    async submitGoodsReceivedNote(requestParameters: SubmitGoodsReceivedNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.submitGoodsReceivedNoteRaw(requestParameters, initOverrides);
    }

    /**
     * Submit an order
     */
    async submitOrderRaw(requestParameters: SubmitOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling submitOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/orders/{id}/submit`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Submit an order
     */
    async submitOrder(requestParameters: SubmitOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.submitOrderRaw(requestParameters, initOverrides);
    }

    /**
     * Update an existing order
     */
    async updateOrderRaw(requestParameters: UpdateOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/orders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: OrderUpdateRequestToJSON(requestParameters.orderUpdateRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update an existing order
     */
    async updateOrder(requestParameters: UpdateOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOrderRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const ListOrdersSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListOrdersSortDirectionEnum = typeof ListOrdersSortDirectionEnum[keyof typeof ListOrdersSortDirectionEnum];
/**
 * @export
 */
export const ListStoreOrderVariancesVarianceThresholdPercentEnum = {
    _30: '30',
    _50: '50',
    _75: '75',
    _100: '100'
} as const;
export type ListStoreOrderVariancesVarianceThresholdPercentEnum = typeof ListStoreOrderVariancesVarianceThresholdPercentEnum[keyof typeof ListStoreOrderVariancesVarianceThresholdPercentEnum];
/**
 * @export
 */
export const ListSupplierStoreOrderVariancesVarianceThresholdPercentEnum = {
    _30: '30',
    _50: '50',
    _75: '75',
    _100: '100'
} as const;
export type ListSupplierStoreOrderVariancesVarianceThresholdPercentEnum = typeof ListSupplierStoreOrderVariancesVarianceThresholdPercentEnum[keyof typeof ListSupplierStoreOrderVariancesVarianceThresholdPercentEnum];
/**
 * @export
 */
export const ListSupplierStoreOrderVariancesMinimumOverdueDaysEnum = {
    _0: '0',
    _2: '2',
    _3: '3',
    _7: '7',
    _14: '14'
} as const;
export type ListSupplierStoreOrderVariancesMinimumOverdueDaysEnum = typeof ListSupplierStoreOrderVariancesMinimumOverdueDaysEnum[keyof typeof ListSupplierStoreOrderVariancesMinimumOverdueDaysEnum];
